require('./depositsView.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { connect } = require('react-redux');
const classNames = require('classnames');
// @ actions
const depositsActions = require('actions/deposits');
import * as offersActions from 'actions/offersActions';
const contractsActions = require('actions/contracts')
const landingActions = require('actions/landings');
const hiringProductBannersActions = require('actions/hiringProductBanners');
// @ commons
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKCover } = require('commonsComponents/OKCover');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKIconTask } = require('commonsComponents/OKIconTask');
const { PopoverMenu } = require('commonsComponents/popoverMenu');
import { EmptyState } from 'commonsComponents/emptyState';
// @ components
const { CommercialAdsCCValidated: CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const DepositsProductBanners = require('components/deposits/depositsProductBanners/depositsProductBanners');
const DepositsProductCMSBanners = require('components/deposits/depositsProductCMSBanners/depositsProductCMSBanners');
const WebappRender = require('components/conditionalRender/webappRender');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const DepositsProductDropdown = require('components/deposits/depositsProductDropdown/depositsProductDropdown');
const RiskProduct = require('components/riskProduct/riskProduct');
import MyDepositsSection from './components/myDepositsSection/myDepositsSection';
const { DepositsBox } = require('components/deposits/depositsBox/depositsBox');
import { OfferExamples } from '../../components/offersExample/offersExample';
import DepositsEmptyState from './components/depositsEmptyView/DepositsEmptyState';
// @ constants
import { DEPOSITS_TOPBAR, GC, HIDE_NEW_DEPOSIT, RENEWAL_DEPOSIT_EXTENDED_COUNTRIES, RENEWAL_DEPOSIT_ORDER_COUNTRIES } from 'constants/flagBasedFeatures';
const { GRAPHIC_TUTOR_TYPE_2, DEPOSIT_CLOSED_FULL_URL, DEPOSIT_CLOSED_URL } = require('constants/index');
const { DEPOSIT_18_MONTHS_ALIAS } = require('constants/hiringProductInformation');
const { 
  BUTTON_CLICK, 
  DEPOSIT_CANCEL_EVENT_TAG, 
  DEPOSIT_EMPTY_STATE_LANDING, 
  DEPOSIT_EMPTY_STATE_SEE_CLOSED_DEPOSITS, 
  DEPOSIT_EMPTY_STATE_CLOSED_DEPOSITS_CLICK 
} = require('constants/tagging');
import { MINIMUM_DEPOSITS_TO_BE_SHOWN } from './constants/depositsView';
// @ utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { contactCenterClassName, conditionalClassName } = require('utilities/conditionals/conditionalClassname')
const { recordLink } = require("utilities/tagging");
import { offersDepositAdapter } from '../../components/offers/adapters/depositsAdapter';
import { filterDeposits, sortDepositsByExpirationDate } from './helpers/sortingHelper';

class DepositsView extends React.Component {
  constructor(props) {
    super(props);

    this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    this.handleClosedDepositsClick = this.handleClosedDepositsClick.bind(this);
    this.handleDepositBoxClick = this.handleDepositBoxClick.bind(this);
    this.hasDeposits = this.hasDeposits.bind(this);
    this.isClosed = this.isClosed.bind(this);
    this.handleLoadMoreClick = this.handleLoadMoreClick.bind(this);
    this.hasOffers = this.hasOffers.bind(this)
    this.handleRequestToHideOfferPost = this.handleRequestToHideOfferPost.bind(this)

    this.state = {
      loadingContractInfo: __CONTACT_CENTER__,
      minimumDepositsToBeShown: MINIMUM_DEPOSITS_TO_BE_SHOWN,
      showAllDeposits: false,
      showEmptyState: false
    };
  }

  componentDidMount() {
    const { flagBasedFeatures, history, immGlobalPosition, requestRetentionDepositsData } = this.props;
    if (!immGlobalPosition.getIn(['savings', 'allSavings']).size && !flagBasedFeatures.get(DEPOSITS_TOPBAR)) {
        history.push('*');
    }
    scrollToTop();
    this.props.requestDeposits(3);
    if (this.props.gestorCrossEnabled) {
      this.props.getHiringProductBanners([{ alias: DEPOSIT_18_MONTHS_ALIAS }]);
    }

    if (__CONTACT_CENTER__) {
      requestRetentionDepositsData(() => {
        this.setState({
          loadingContractInfo: false,
        });
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { immDeposits } = this.props;
    const { immDeposits: prevImmDeposits } = prevProps;
    const isFetched = immDeposits.get('isFetched');
    const hideOfferSuccess = immDeposits.getIn(['hideOfferPost', 'success'])
    const prevIsFetched = prevImmDeposits.get('isFetched');

    if ((!prevIsFetched && isFetched) || hideOfferSuccess) {
      this.props.fetchOffers();
      this.props.resetHideDepositOfferPost();
    }
  }

  componentWillUnmount() {
    const { resetFetchedImpositions, resetOffersData } = this.props
    resetOffersData()
    resetFetchedImpositions()
  }

  buildClosedDepositsHeaderButton() {
    const targetElement = (
        <div className="visible-xs">
            <OKIconTask activeHover={false} icon="icon-s-op-comp" type="standalone" style="dark-bg" />
        </div>
    );
    const moreOptions = [{
      link: `/myprofile/deposits/closed`,
      text: formatText('deposits-closedDepositsButtonTitle'),
    }];
    let dataToRender = (
        <div className="deposits-view__closed-deposits-button">
            <div className="hidden-xs">
                <OKButton modifier="ghost" inverse={true} onClick={this.handleClosedDepositsClick}>
                    <FormattedText value="deposits-closedDepositsButtonTitle" />
                </OKButton>
            </div>
            <PopoverMenu
                target={targetElement}
                items={moreOptions}
                placement="bottomRight"
        />
        </div>
    );

    if (!this.hasClosedDeposits()) {
      const disabledClosedDepositsButton = (
          <div className="deposits-view__disabled-closed-deposits-button">
              <div className="hidden-xs">
                  <OKButton disabled={true} inverse={true} modifier="ghost">
                      <FormattedText value="deposits-closedDepositsButtonTitle" />
                  </OKButton>
              </div>
          </div>
      );

      dataToRender = (
          <OKTooltip
              content="deposits-disabledClosedDepositsButtonTitle"
              modifier="dark-bg"
              offset={[0, -15]}
              target={disabledClosedDepositsButton}
        />
      );
    }

    return dataToRender;
  }

  handleLoadMoreClick() {
    this.setState({
      showAllDeposits: !this.state.showAllDeposits,
    })
  }

  buildHeader() {
    const { immDeposits, flagBasedFeatures } = this.props;
    const isFetching = immDeposits.get('isFetching');
    const title = formatText('deposits-title');
    const tutorial = (
        <TutorialLauncher
            type={GRAPHIC_TUTOR_TYPE_2}
            title={formatText('tutorials-depositsTitle')}
      />
    );
    const closedDepositsButton = this.buildClosedDepositsHeaderButton();
    let size = 'small';
    let coverContent = (
        <OKHeaderLanding
            title={title}
            tutorial={tutorial}
            inputClassName="ok-header-landing--deposits">
            <ContactCenterRender>
                <div className="deposits-view__header-buttons-container">
                    <DepositsProductDropdown
                        customClassName="deposits-view__hire-deposits-dropdown"
                        dropdownItemStyle="deposits-view__hire-deposits-dropdown-item"
                        flagBasedFeatures={flagBasedFeatures}
            />
                    {closedDepositsButton}
                </div>
            </ContactCenterRender>
            <WebappRender>
                {closedDepositsButton}
            </WebappRender>
        </OKHeaderLanding>
    );

    if (this.isClosed()) {
      size = 'medium';
      const mappingBreadcrumb = [
        {
          text: formatText('breadcrumb-deposits'),
          url: '/myprofile/deposits/',
        },
        {
          text: formatText('breadcrumb-closedDeposits'),
          url: `/myprofile/deposits/closed/`,
        },
      ];

      coverContent = (
          <OKHeaderSubPage
              breadcrumbConfig={mappingBreadcrumb}
              finalTitle={getFinalTitle('breadcrumb-closedDeposits')}
        />
      );
    } else if (isFetching) {
      coverContent = <LoadingSection />;
    }

    return (
        <OKCover size={size} section="deposits" customClass="col-xs-12">
            {coverContent}
        </OKCover>
    );
  }

    handleClosedDepositsClick(isEmptyState = false) {
        const url = `/myprofile/deposits/closed`;
        const eventTag = isEmptyState ? DEPOSIT_EMPTY_STATE_CLOSED_DEPOSITS_CLICK : DEPOSIT_CANCEL_EVENT_TAG;
        const eventAction = isEmptyState ? DEPOSIT_EMPTY_STATE_SEE_CLOSED_DEPOSITS : BUTTON_CLICK;
        const eventCategory = isEmptyState ? DEPOSIT_EMPTY_STATE_LANDING : window.utag_last_name;
        recordLink(eventCategory, eventAction, eventTag);
        this.setState({
          showAllDeposits: false,
        })
        this.props.history.push(url);
    }

  handleDepositBoxClick(isExpanded, index) {
    const isClosed = this.props.location.pathname === DEPOSIT_CLOSED_URL;
    this.props.boxToggle(isExpanded, index, isClosed ? 'depositsClose' : 'depositsOpen');
  }

  hasClosedDeposits() {
    const immDepositsById = this.props.immDeposits.get('byId');
    let hasClosed = false;

    if (this.hasDeposits()) {
      hasClosed = immDepositsById.some(deposit => {
        return deposit.get('isClosed');
      });
    }

    return hasClosed;
  }

  hasDeposits() {
    const { immDeposits } = this.props;

    return !immDeposits.get('isFetching') && immDeposits.get('byId');
  }

  isClosed() {
    const { match: { params: { depositId } }, immDeposits } = this.props;
    const deposits = immDeposits.get('byId');
    let isClosed = this.props.location.pathname === DEPOSIT_CLOSED_URL;

    if (depositId && deposits) {
      isClosed = deposits.getIn([depositId, 'isClosed']);
    }

    return isClosed;
  }

  hasOffers(offersData) {
    const { immOffers } = this.props
    return immOffers.get('fetched') && offersData && Object.keys(offersData).length
  }

  handleRequestToHideOfferPost = (depositContractAndImpositionList) => {
    const { requestHideDepositOfferPost } = this.props
    requestHideDepositOfferPost(depositContractAndImpositionList)
  }

  buildDepositsContent(offersData) {
    const {
      flagBasedFeatures,
      immDeposits,
      immOffers,
      immInvestmentFunds,
      immLandingDepositsOpen,
      immLandingDepositsClose,
      immGlobalPosition,
      immProfile,
      originCountry,
      setRenewalDepositId,
      setRenewalOrTransferToken,
      setMaxImportAmount,
      resetHideDepositOfferPost,
    } = this.props;
    const isFetching = immDeposits.get('isFetching');
    let myBoxes = [];
    let immDepositsFiltered = [];
    let lastOfferIndex;
    if (this.hasDeposits() && immOffers.get('fetched')) {
      const isCurrentOpenDepositView = location.pathname !== DEPOSIT_CLOSED_FULL_URL;
      const immGlobalPositionSavings = __CONTACT_CENTER__ ? immGlobalPosition.getIn(['savings', 'allSavings']) : undefined;
      const immSortedDeposits = sortDepositsByExpirationDate(immDeposits.get('byOrder'),immDeposits.get('byId'));
      const hasClosedDeposits = this.hasClosedDeposits();
      immDepositsFiltered = filterDeposits(immSortedDeposits, immDeposits, offersData, isCurrentOpenDepositView);
      let defaultNumberOfBoxesToShow;
      lastOfferIndex = offersData && immDepositsFiltered.findLastIndex( id => (offersData[immDeposits.getIn(['byId', id, 'contract', 'contractNumber'])] !== undefined))+1;
      if (offersData && lastOfferIndex > MINIMUM_DEPOSITS_TO_BE_SHOWN) {
          defaultNumberOfBoxesToShow = lastOfferIndex;
      } else {
          defaultNumberOfBoxesToShow = MINIMUM_DEPOSITS_TO_BE_SHOWN;
      }

      const hideOfferPostState = immDeposits.get('hideOfferPost').toJS()
      const immDepositsListFiltered = !this.state.showAllDeposits && !__CONTACT_CENTER__ ? immDepositsFiltered.slice(0, defaultNumberOfBoxesToShow) : immDepositsFiltered;
      myBoxes = immDepositsListFiltered.map((id) => {
          const immGlobalPositionSaving = __CONTACT_CENTER__
              ? immGlobalPositionSavings.find(saving => {
                  return saving.get('id') === id;
              })
              : undefined;

          const landingDeposits = isCurrentOpenDepositView
              ? immLandingDepositsOpen
              : immLandingDepositsClose

          const expanded = (landingDeposits || []).includes(id);

          const isFetched = immDeposits.get('isFetched')

        return (
          <div>

            <DepositsBox
              offersData={offersData}
              key={id}
              setRenewalOrTransferToken={setRenewalOrTransferToken}
              setMaxImportAmount={setMaxImportAmount}
              setRenewalDepositId={setRenewalDepositId}
              immFlagBasedFeatures={flagBasedFeatures}
              immProfile={immProfile}
              hideNewDeposit={flagBasedFeatures.get(HIDE_NEW_DEPOSIT)}
              immGlobalPositionSaving={immGlobalPositionSaving}
              index={id}
              immDeposit={immDeposits.getIn(['byId', id])}
              isClosed={this.isClosed()}
              immInvestmentFunds={immInvestmentFunds}
              actualDate={immDeposits.get('actualDate')}
              depositIndex={id}
              expanded={expanded}
              onClick={this.handleDepositBoxClick}
              originCountry={originCountry}
              isFetched={isFetched}
              onHideOfferPost={this.handleRequestToHideOfferPost}
              hideOfferPostState={hideOfferPostState}
              resetHideDepositOfferPost={resetHideDepositOfferPost}
            />
          </div>
        )
      }).toArray()

      if (isCurrentOpenDepositView && !myBoxes.length) {
        this.setState({
          showEmptyState: true,
        });
        if (__CONTACT_CENTER__) {
          myBoxes.push(
            <section className="deposits-view__empty-state">
              <EmptyState primaryText={formatText('deposits-noCurrentDeposits')} iconType="noitems-banking" withMargin={false} />
            </section>
          )
        } else {
          myBoxes.push(<DepositsEmptyState hasClosedDeposits={hasClosedDeposits} hasOffers={!!this.hasOffers(offersData)} handleLinkClick={this.handleClosedDepositsClick} />);
        }
      }
    } else if (isFetching || immOffers.get('loading')) {
      myBoxes.push(
          <OKSectionBox className="ok-section-box--larger">
              <LoadingSection />
          </OKSectionBox>,
      );
    }

    if (__CONTACT_CENTER__) {
      const leftDeposits = myBoxes.filter((value, index) => !(index % 2));
      const rightDeposits = myBoxes.filter((value, index) => index % 2);

      const allDepositBoxes = (
          <section className="row">
              {myBoxes}
          </section>
      );

      const leftDepositBoxes = (
          <section className="row">
              {leftDeposits}
          </section>
      );

      const rightDepositBoxes = (
          <section className="row">
              {rightDeposits}
          </section>
      );

      return ({ allDepositBoxes, leftDepositBoxes, rightDepositBoxes });
    }

    if (!__CONTACT_CENTER__) {
      return <MyDepositsSection
        handleLoadMoreClick={this.handleLoadMoreClick}
        showAllDeposits={this.state.showAllDeposits}
        lastOfferIndex={offersData ? lastOfferIndex : 0}
        filteredSize={immDepositsFiltered.size}
      >
        {myBoxes}
      </MyDepositsSection>
    } else {
      return (
          <section className="row">
              {myBoxes}
          </section>
      );
    }
  }

  render() {
    const {
      immDeposits,
      immOffers,
      location, 
      immHiringProductBanners, 
      flagBasedFeatures, 
      gestorCrossEnabled,
      originCountry
    } = this.props;
    const { showEmptyState } = this.state
    const coverContent = this.buildHeader();
    const closedDepositsPath = location.pathname === DEPOSIT_CLOSED_URL;
    const bodyClassName = contactCenterClassName('deposits-view__body', 'grid-view__body');
    const containerClassName = classNames('container-fluid', {
      'grid-view--content-position-negative': closedDepositsPath,
      'grid-view--content-position-positive': !closedDepositsPath,
    });
    const offers = immOffers.get('fetched') && !immOffers.get('error') && !!immOffers.get('data') && !!immOffers.getIn(['data', 'offers'])?.size &&
      offersDepositAdapter({ offers: immOffers,
        featureFlags: flagBasedFeatures,
        immDeposits 
      });
    const offersData = offers && offers.offers ? offers.offers : null;
    const offerExamplesData = offers && offers.examples ? offers.examples : [];
    const hasRenewalOffers = !!this.hasOffers(offersData);
    let content;


    if (immDeposits.get('isFetching') || !immDeposits.get('isFetched') || !immOffers.get('fetched')) {
      content = !__CONTACT_CENTER__
      ? <LoadingSection />
      : content = {
        allDepositBoxes: (<LoadingSection />),
        leftDepositBoxes: (<LoadingSection />),
        rightDepositBoxes: (<LoadingSection />),
      };
    } else {
      content = this.buildDepositsContent(offersData);
    }

    const depositsLeftColumnClassName = conditionalClassName('col-xs-12 col-md-9', showEmptyState ? 'col-xs-12' : 'deposits-view__left-column col-xs-6', '');
    const depositsRightColumnClassName = conditionalClassName('col-xs-12 col-md-3', 'deposits-view__right-column col-xs-6', '');
    let depositProductBanner;
    if (gestorCrossEnabled && flagBasedFeatures.get(GC)) {
      depositProductBanner = (
          <DepositsProductCMSBanners
              offersData={offersData}
              immDeposits={immDeposits}
              immFlagBasedFeatures={flagBasedFeatures}
              immHiringProductBanners={immHiringProductBanners}
              offerExamplesData={offerExamplesData}
        />
      );
    } else {
      depositProductBanner = (
          <DepositsProductBanners
              immDeposits={immDeposits}
              immFlagBasedFeatures={flagBasedFeatures}
              offersData={offersData}
              offerExamplesData={offerExamplesData}
              originCountry={originCountry}
        />
      );
    }

    return (
        <div className="deposits-view">
            <div className="container-fluid">
                <div className="row">
                    {coverContent}
                </div>
            </div>
            <div className={bodyClassName}>
                <div className={containerClassName}>
                    <div className="row">
                        <div className="col-xs-12">
                            {
                              hasRenewalOffers && (
                                  <WebappRender>
                                      <div className="row deposits-view__risk-level">
                                          <RiskProduct
                                              immFlagBasedFeatures={flagBasedFeatures}
                                              isAlertLiquidity={true}
                                          />
                                      </div>
                                  </WebappRender>
                              )
                            }
                        </div>
                        <div className={depositsLeftColumnClassName}>
                            <ContactCenterRender>
                                {content.leftDepositBoxes}
                            </ContactCenterRender>
                            <WebappRender>
                                <div className="row">
                                    <div className="col-md-12">
                                        {content}
                                        {depositProductBanner}
                                    </div>
                                </div>
                            </WebappRender>
                        </div>
                        <div className={depositsRightColumnClassName}>
                            <ContactCenterRender>
                                {content.rightDepositBoxes}
                            </ContactCenterRender>
                            <WebappRender>
                                <div className="row">
                                    <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                                        <CommercialAds path="deposits" type="banner-b" />
                                    </div>
                                    <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                                        <CallMeBack hasEntrance={false} isSmall={true}
                                            pageTitle={formatText('breadcrumb-deposits')} />
                                    </div>
                                </div>
                            </WebappRender>
                        </div>
                    </div>
                </div>
            <div className="deposits-view__offer-examples-container row">
              <ContactCenterRender>
                <OfferExamples examples={offerExamplesData} originCountry={originCountry} />
              </ContactCenterRender>
            </div>
            </div>
            <div className="container-fluid grid-view__cross-selling">
              <div className="row">
                <CommercialAds path="deposits" type="cross-selling" />
              </div>
            </div>
        </div>
    );
  }
}

DepositsView.propTypes = {
  boxToggle: PropTypes.func,
  fetchOffers: PropTypes.func.isRequired,
  flagBasedFeatures: PropTypes.object.isRequired,
  gestorCrossEnabled: PropTypes.bool.isRequired,
  getHiringProductBanners: PropTypes.func,
    history: PropTypes.object.isRequired,
  immDeposits: PropTypes.object.isRequired,
  immGlobalPosition: PropTypes.object.isRequired,
  immHiringProductBanners: PropTypes.object.isRequired,
  immInvestmentFunds: PropTypes.object.isRequired,
  immLandingDepositsClose: PropTypes.object,
  immLandingDepositsOpen: PropTypes.object,
  immOffers: PropTypes.object,
  originCountry: PropTypes.string.isRequired,
  match: PropTypes.object.isRequired,
  requestDeposits: PropTypes.func.isRequired,
  requestRetentionDepositsData: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  setRenewalOrTransferToken: PropTypes.func.isRequired,
  setRenewalDepositId: PropTypes.func.isRequired,
  resetFetchedImpositions: PropTypes.func.isRequired
};

module.exports.constructor = DepositsView;

module.exports.DepositsView = connect(
  state => ({
    flagBasedFeatures: state.flagBasedFeatures,
    gestorCrossEnabled: state.flagBasedFeatures.get('web-gc-enabled'),
    immDeposits: state.deposits,
    immGlobalPosition: state.globalPosition,
    immHiringProductBanners: state.hiringProductBanners,
    immInvestmentFunds: state.investmentFunds.get('list'),
    immLandingDepositsOpen: state.landings.get('expandedBoxes').get('depositsOpen'),
    immLandingDepositsClose: state.landings.get('expandedBoxes').get('depositsClose'),
    immProfile: state.profile,
    originCountry: state.profile.get('originCountry'),
    immOffers: state.offers,
  }), {
    getHiringProductBanners: hiringProductBannersActions.getHiringProductBanners,
    requestDeposits: depositsActions.requestDeposits,
    resetFetchedImpositions: depositsActions.resetFetchedImpositions,
    requestRetentionDepositsData: depositsActions.requestRetentionDepositsData,
    setRenewalOrTransferToken: contractsActions.setRenewalOrTransferToken,
    setMaxImportAmount: contractsActions.setMaxImportAmount,
    setRenewalDepositId: contractsActions.setRenewalDepositId,
    boxToggle: landingActions.boxToggle,
    fetchOffers: offersActions.fetchOffers,
    resetOffersData: offersActions.reset,
    requestHideDepositOfferPost: depositsActions.requestHideDepositOfferPost,
    resetHideDepositOfferPost: depositsActions.resetHideDepositOfferPost,
  },
)(withRouter(DepositsView));
